export const getApplicationFromPath = (path: string): string => {
  const splittedPath = path.split('\\');

  return splittedPath[splittedPath.length - 1];
};
